import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 48 48" fill="none" {...props}>
      <title>{props.title || 'Tracks'}</title>
      <g>
        <path
          d="M24 0C37.2514 0 48 10.7486 48 24C48 37.2514 37.2514 48 24 48C10.7486 48 0 37.2514 0 24C0 10.7486 10.7486 0 24 0Z"
          fill="#FFD6B0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 14.4702C9 13.9179 9.44772 13.4702 10 13.4702H21.3333C21.8856 13.4702 22.3333 13.9179 22.3333 14.4702V25.2422C22.3333 25.7944 21.8856 26.2422 21.3333 26.2422H10C9.44772 26.2422 9 25.7944 9 25.2422V14.4702Z"
          fill="#FFD6B0"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 17.3999H22.3333"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5555 14.9437V11.5051"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.7778 14.9437V11.5051"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.6666 19.8562H12.8032C12.9487 19.8569 13.0847 19.9363 13.1674 20.0686C13.2501 20.201 13.269 20.3697 13.218 20.5203L12.1111 23.786"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.5556 22.8036C16.5556 23.3462 16.1576 23.786 15.6667 23.786C15.1758 23.786 14.7778 23.3462 14.7778 22.8036V20.8387C14.7778 20.2961 15.1758 19.8562 15.6667 19.8562C16.1576 19.8562 16.5556 20.2961 16.5556 20.8387V22.8036Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.6667 20.8385H19C18.67 20.8027 18.3742 21.0642 18.3334 21.428C18.3334 22.3122 19.6667 22.3122 19.6667 23.1964C19.6259 23.5602 19.3301 23.8217 19 23.7859H18.3334"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17 27.5789C17 27.0266 17.4477 26.5789 18 26.5789H28.5C29.0523 26.5789 29.5 27.0266 29.5 27.5789V37.5526C29.5 38.1048 29.0523 38.5526 28.5 38.5526H18C17.4477 38.5526 17 38.1048 17 37.5526V27.5789Z"
          fill="#FFD6B0"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17 30.2632H29.5"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.3334 27.9605V24.7368"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.1667 27.9605V24.7368"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.0834 35.3291C24.0834 35.8378 23.7103 36.2501 23.2501 36.2501C22.7898 36.2501 22.4167 35.8378 22.4167 35.3291V33.487C22.4167 32.9783 22.7898 32.5659 23.2501 32.5659C23.7103 32.5659 24.0834 32.9783 24.0834 33.487V35.3291Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27 33.487H26.375C26.0656 33.4534 25.7883 33.6985 25.75 34.0396C25.75 34.8685 27 34.8685 27 35.6975C26.9617 36.0385 26.6844 36.2837 26.375 36.2501H25.75"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.9167 36.2498C20.3769 36.2498 20.75 35.8375 20.75 35.3288C20.75 34.8201 20.3769 34.4077 19.9167 34.4077C19.4565 34.4077 19.0834 34.8201 19.0834 35.3288C19.0834 35.8375 19.4565 36.2498 19.9167 36.2498Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.9167 34.408C20.3769 34.408 20.75 33.9957 20.75 33.487C20.75 32.9783 20.3769 32.5659 19.9167 32.5659C19.4565 32.5659 19.0834 32.9783 19.0834 33.487C19.0834 33.9957 19.4565 34.408 19.9167 34.408Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25 11.9648C25 11.4126 25.4477 10.9648 26 10.9648H37.3333C37.8856 10.9648 38.3333 11.4126 38.3333 11.9648V22.7368C38.3333 23.2891 37.8856 23.7368 37.3333 23.7368H26C25.4477 23.7368 25 23.2891 25 22.7368V11.9648Z"
          fill="#FFD6B0"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25 14.8948H38.3333"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.5555 12.4386V9"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M34.7778 12.4386V9"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.5556 20.2982C32.5556 20.8408 32.1576 21.2807 31.6667 21.2807C31.1758 21.2807 30.7778 20.8408 30.7778 20.2982V18.3333C30.7778 17.7907 31.1758 17.3508 31.6667 17.3508C32.1576 17.3508 32.5556 17.7907 32.5556 18.3333V20.2982Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M35.6667 18.3334H35C34.67 18.2975 34.3742 18.559 34.3334 18.9228C34.3334 19.807 35.6667 19.807 35.6667 20.6913C35.6259 21.055 35.3301 21.3166 35 21.2807H34.3334"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M29 18.3335V19.8072C29 20.6211 28.403 21.2809 27.6666 21.2809V21.2809"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.1111 19.3157C28.602 19.3157 28.9999 18.8759 28.9999 18.3333C28.9999 17.7907 28.602 17.3508 28.1111 17.3508C27.6201 17.3508 27.2222 17.7907 27.2222 18.3333C27.2222 18.8759 27.6201 19.3157 28.1111 19.3157Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </Icon>
  )
}
